module.exports = __webpack_public_path__ + "img/mobile-neck-15_24x585.158f554c.png";